<template>
    <div>
        <div class="guest-background" />
        <slot />
        <span class="app-version">{{ $t('ceremony.version', { version: appVersion }) }}</span>
    </div>
</template>

<script setup>

    const appVersion = APP_VERSION;

</script>

<style lang="scss" scoped>
    .guest-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        background-image: url('../../assets/lite/guest-background.jpg');
        background-color: #2d2d2d;
        background-size: cover;
        background-position: 50%;
    }

    .app-version {
        font-size: 12px;
        color: #fff;
        position: absolute;
        bottom: 5px;
        left: 15px;
        pointer-events: none;
    }
</style>
